import React from "react";
import { SmallText } from "../../components/core/utility";
import styled from "@emotion/styled";
import { Table, TableBody, TableRow, Cell, TableHeader, TableHead } from "@vds/tables";

export const CustomisedTable = styled(Table)`
  border-top: unset;
  font-family: Verizon-NHG-eTX;
  margin-top: 2rem;
  margin-bottom: 0rem;
  width:90%;
  & thead {
    border: 0.0625rem solid #d8dada;
    & tr {
      & th {
        padding: unset;
        height: 1.85rem;
        padding: 4px 2px 2px 14px;
        border-right: 1px solid #d6d2d2;
       
      }
    }
  }
  & tbody {
    border: 0.0625rem solid #d8dada;
    & tr {
      & td {
        padding: unset;
        height: 1.85rem;
        padding: 4px 2px 2px 14px;
        border-right: 1px solid #d6d2d2;
    }
  }
`;

export const OrderTrackingInfoTable = ({ data }) => {
  return (
    <CustomisedTable topLine="none" role="table">
      <TableHead role="row">
        <TableHeader role="columnheader" width="25.5%">
          <SmallText bold>Planned Quantity</SmallText>
        </TableHeader>
        <TableHeader role="columnheader" width="20.5%">
          <SmallText bold>PGI Date</SmallText>
        </TableHeader>
        <TableHeader role="columnheader" width="20.5%">
          <SmallText bold>Self Installed</SmallText>
        </TableHeader>
        <TableHeader role="columnheader" width="20.5%">
          <SmallText bold>Installed</SmallText>
        </TableHeader>
        <TableHeader role="columnheader" width="20.5%">
          <SmallText bold>Return</SmallText>
        </TableHeader>
      </TableHead>
      <TableBody role="rowgroup">
        <TableRow role="row">
          <Cell role="cell">
            {data?.plannedQuantity.map((plannedQuantity, index) => (
              <SmallText key={index}>{plannedQuantity}</SmallText>
            ))}
          </Cell>
          <Cell role="cell">
            {data?.pgiDate.map((pgiDate, index) => (
              <SmallText key={index}>{pgiDate}</SmallText>
            ))}
          </Cell>
          <Cell role="cell">
            {data?.selfInstalled.map((selfInstalled, index) => (
              <SmallText key={index}>{selfInstalled}</SmallText>
            ))}
          </Cell>
          <Cell role="cell">
            {data?.installed.map((installed, index) => (
              <SmallText key={index}>{installed}</SmallText>
            ))}
          </Cell>
          <Cell role="cell">
            {data?.returnedOrder.map((returnedOrder, index) => (
              <SmallText key={index}>{returnedOrder}</SmallText>
            ))}
          </Cell>
        </TableRow>
      </TableBody>
    </CustomisedTable>
  );
};

export default OrderTrackingInfoTable;
